<template>
  <AppLayout>
    <div class="col-12 layout-spacing">
      <div class="widget widget-six">
        <div class="widget-heading">
          <div class="row">
            <div class="col-12 d-inline-flex align-items-center">
              <h4 class="me-3 my-0">Lista pracowników</h4>
            </div>
          </div>
        </div>
        <div class="widget-content">
          <div class="row">
            <div class="col-auto d-flex align-items-center me-3">
              <select v-model="selectedDepartament" class="form-select form-sm mb-2" style="width: 360px;"
                      @change="loadAllDataForUsers">
                <option value="0">WSZYSCY PRACOWNICY</option>
                <option v-for="(department, depId) in departaments" :key="depId" :value="department.id">
                  {{ department.name }}
                </option>
                <option value="-1">POZOSTALI PRACOWNICY</option>
              </select>

		  
            </div>
            <div class="col-auto d-flex align-items-center">
              <input type="text" v-model="searchQuery" placeholder="Szukaj pracownika..."
                     class="form-control form-sm mb-2" style="width: 220px;"/>
            </div>
            <div class="col-auto d-flex align-items-center">
 			  
			  		  <a :href="`/bhp/terminy/lista/pdf/0`" target="_blank" class="btn btn-primary">
			Pobierz listę
		  </a>            </div>

          </div>
          <div class="table-responsive w-100">
            <table class="table table-bordered table-hover">
              <thead>
              <tr>
                <th class="bg-gray-100 text-center" style="width: 15px;">#</th>
                <th class="bg-gray-100 text-start" @click="sortBy('userName')" style="width: 25%; cursor:pointer;">
                  Pracownik
                  <span v-if="sortKey === 'userName'"> {{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th class="bg-gray-100 text-start" @click="sortBy('position')" style="width: 35%; cursor:pointer">
                  Stanowisko
                  <span v-if="sortKey === 'position'"> {{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th class="bg-gray-100 text-start" @click="sortBy('oddzial')" style="width: 8%; cursor:pointer">
                  Oddział
                  <span v-if="sortKey === 'oddzial'"> {{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                </th>
                <th class="bg-gray-100 text-start" @click="sortBy('alerts')" style="cursor:pointer">
                  Alarm
                  <span v-if="sortKey === 'alerts'"> {{ sortOrder === 'asc' ? '▲' : '▼' }}</span>
                </th>
              </tr>
              </thead>
              <tbody>
              <tr v-for="(user, i) in filteredAndSortedUsers" :key="user.userId">
                <td style="width: 15px;">{{ i + 1 }}</td>
                <td style="width: 25%;" class="text-start">
                  <Link :href="route('bhp.terminy.show.user', user.userId)" class="text-primary"><span
                      v-if="user.alerts && user.alerts.length" class="text-warning">⚠️ </span>{{ user.userName }}
                  </Link>
                </td>
                <td style="width: 35%;" class="text-start">{{ user.position }}</td>
                <td style="width: 15%;" class="text-start">{{ user.oddzial }}</td>
                <td class="text-start">
                  <div v-if="user.alerts && user.alerts.length">
                    <p v-for="(alert, index) in user.alerts" :key="index" class="text-warning">{{ alert }}</p>
                  </div>

                </td>
              </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script>
import AppLayout from "@/Layouts/App.vue";
import axios from 'axios';

export default {
  components: {AppLayout},
  props: {
    departaments: Array,
    departamentId: Number,
  },
  data() {
    const today = new Date();
    return {
      users: [],
      selectedDepartament: this.departamentId ?? 1,
      searchQuery: "",
      sortKey: "userName",
      sortOrder: "desc",
    };
  },
  computed: {
    filteredAndSortedUsers() {
      let result = this.users;

      // filtr po nazwisku
      if (this.searchQuery) {
        const q = this.searchQuery.toLowerCase();
        result = result.filter((u) => u.userName?.toLowerCase().includes(q));
      }

      // sortowanie
      return result.slice().sort((a, b) => {
        let aVal = "";
        let bVal = "";

        if (this.sortKey === "userName") {
          aVal = a.userName?.toLowerCase() ?? "";
          bVal = b.userName?.toLowerCase() ?? "";
        } else if (this.sortKey === "position") {
          aVal = a.position?.toLowerCase() ?? "";
          bVal = b.position?.toLowerCase() ?? "";
        } else if (this.sortKey === "oddzial") {
          aVal = a.oddzial?.toLowerCase() ?? "";
          bVal = b.oddzial?.toLowerCase() ?? "";
        } else if (this.sortKey === "alerts") {
          // sortowanie np. po liczbie alertów
          aVal = a.alerts?.length ?? 0;
          bVal = b.alerts?.length ?? 0;
        }

        if (aVal < bVal) return this.sortOrder === "asc" ? -1 : 1;
        if (aVal > bVal) return this.sortOrder === "asc" ? 1 : -1;
        return 0;
      });
    },
  },
  methods: {
    async loadAllDataForUsers() {
      try {
        const response = await axios.get(
            route("bhp.terminy.tabela"),
            {
              params: {
                departament: this.selectedDepartament,
              },
            }
        );
        this.users = response.data.users.map((u) => {
          return {
            userId: u.userId,
            userName: u.userName,
            position: u.user_stanowisko, // dodanie stanowiska
            oddzial: u.oddzial, // dodanie stanowiska
            alerts: u.alerts,             // dodanie alertów
          };
        });
      } catch (error) {
        console.error("Błąd ładowania danych:", error);
      }
    },

    sortBy(key) {
      if (this.sortKey === key) {
        this.sortOrder = this.sortOrder === "asc" ? "desc" : "asc";
      } else {
        this.sortKey = key;
        this.sortOrder = "asc";
      }
    },
  },
  mounted() {
    this.loadAllDataForUsers();
  },
};
</script>

<style scoped>
table th,
table td {
  min-width: 50px;
  height: 32px;
  text-align: center;
}
.bg-gray-100 {
  background-color: #f5f5f5;
  color: black;
}
.text-start {
  text-align: left;
}

.table tbody tr:nth-child(even) td:not([style*="background-color"]) {
  background-color: #f9f9f9 !important;
}

.table tbody tr:nth-child(odd) td:not([style*="background-color"]) {
  background-color: #ffffff !important;
}

/* hover nadal działa, ale tylko na niekolorowanych komórkach */
.table tbody tr:hover td:not([style*="background-color"]) {
  background-color: #eaeaea !important;
}
</style>
